import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  "data-name": "Lager 1",
  viewBox: "0 0 500 500"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("circle", {
      cx: "250",
      cy: "250",
      r: "192.5",
      fill: "#069378",
      opacity: ".15"
    }, null, -1),
    _createElementVNode("path", {
      fill: "#069378",
      d: "M250 385.32c-28.77 0-56.18-10.82-77.17-30.46-20.89-19.54-33.52-45.97-35.54-74.43a20.7 20.7 0 0 1 5.49-15.56c3.88-4.17 9.37-6.55 15.06-6.55h184.32c5.69 0 11.18 2.39 15.06 6.55a20.74 20.74 0 0 1 5.49 15.56c-2.02 28.45-14.64 54.88-35.54 74.43-21 19.64-48.41 30.46-77.17 30.46m-83.85-99c6.72 40.4 42.12 71 83.85 71s77.13-30.6 83.85-71zM219.98 197.08c.11 1.29.17 2.57.16 3.84-.01 4.99-6.3 7.17-9.46 3.3-7.73-9.48-19.5-15.54-32.69-15.54s-24.96 6.06-32.69 15.55c-3.13 3.85-9.43 1.72-9.45-3.24v-.16c0-24.33 20.61-43.84 45.31-42.03 20.45 1.49 37.06 17.86 38.82 38.28M363.98 197.32c.11 1.29.17 2.57.16 3.84-.01 4.99-6.3 7.17-9.46 3.3-7.73-9.48-19.5-15.54-32.69-15.54s-24.96 6.06-32.69 15.55c-3.13 3.85-9.43 1.72-9.45-3.24v-.16c0-24.33 20.61-43.84 45.31-42.03 20.45 1.49 37.06 17.86 38.82 38.28"
    }, null, -1),
    _createElementVNode("path", {
      fill: "#069378",
      d: "M420.46 78.23c-9.3-9.23-19.21-17.61-29.64-25.1-5.62-4.04-13.33-3.46-18.23 1.43-6.14 6.14-5.3 16.32 1.76 21.38 53.98 38.67 89.3 101.79 89.64 173.02.56 116.85-93.62 213.11-210.45 215.01-122.12 1.99-221.64-98.89-217.42-221.49C40.08 127.47 135.29 35.81 250.36 36c23.32.04 45.78 3.83 66.81 10.8 5.02 1.66 10.54.32 14.28-3.42 7.39-7.39 4.43-20-5.49-23.27C302.03 12.23 276.75 8.09 250.84 8 186.9 7.78 125.21 33.01 79.77 77.99 33.49 123.81 7.99 184.96 8 250.03c0 64.21 25.48 125.69 70.88 171.09 45.79 45.79 106.69 70.97 171.46 70.88 64.12-.09 125.45-25.54 170.78-70.88 46.25-46.25 71.47-107.91 70.87-173.39-.58-63.62-26.37-124.68-71.53-169.5"
    }, null, -1)
  ]))]))
}
export default { render: render }